import { GTMLoanStatus } from '@n2-common/lib/gtm';
import { NavigateFunction } from 'react-router-dom';
import { ApplicationPaths, navigateToStep } from '@n2-common/applicationPages/ApplicationFormsHelpers';

export const OutcomeValues = ['Approve', 'Cancelled', 'Decline', 'Error', 'Pending'] as const;
export type Outcome = typeof OutcomeValues[number];
export type PostLoanApplicationResult =
    | { outcome: Outcome; applicationId: string }
    | { outcome: 'Redirect'; applicationId: string; applicantId: string };

export const outcomeToECommerceStatus = (outCome: Outcome): GTMLoanStatus => {
    switch (outCome) {
        case 'Approve':
            return 'approved';
        case 'Decline':
            return 'declined';
    }
    return 'not set';
};

export function shouldBeTracked(outcome: Outcome) {
    return outcomeToECommerceStatus(outcome) !== 'not set';
}

/**
 * @param result 
 * @param navigate 
 * @param legacy true is used to redirect in router, where false is redirecting to O2-application /offer
 */
export function redirect(result: PostLoanApplicationResult, navigate: NavigateFunction, legacy = true) {
    switch (result.outcome) {
        case 'Approve':
        case 'Pending': // This is taking too long - we redirect to landingpage, and let that take over polling
            location.assign(`${location.protocol}//${location.host}/application/${result.applicationId}/offer`);
            break;

        case 'Cancelled':
            legacy
                ? navigateToStep(ApplicationPaths.canceled, result.applicationId, navigate, null)
                : location.assign(`${location.protocol}//${location.host}/application/${result.applicationId}/rejected`);
            break;

        case 'Decline':
            legacy
                ? navigateToStep(ApplicationPaths.declined, result.applicationId, navigate, null)
                : location.assign(`${location.protocol}//${location.host}/application/${result.applicationId}/rejected`);
            break;

        case 'Error':
            navigateToStep(ApplicationPaths.error, result.applicationId, navigate, null);
            break;

        case 'Redirect':
            location.assign(`${location.protocol}//${location.host}/application/${result.applicationId}/${result.applicantId}/offer`);
            break;
    }
}

export function redirectSecure(result: PostLoanApplicationResult) {
    switch (result.outcome) {
        case 'Approve':
        case 'Pending': // This is taking too long - we redirect to landingpage, and let that take over polling
            location.assign(`${location.protocol}//${location.host}/application/${result.applicationId}/offer`);
            break;
        case 'Redirect':
            location.assign(`${location.protocol}//${location.host}/application/secure/${result.applicationId}/${result.applicantId}/offer`);
            break;

        case 'Cancelled':
        case 'Decline':
            location.assign(`${location.protocol}//${location.host}/application/${result.applicationId}/rejected`);
            break;

        case 'Error':
            throw new Error('Not implemented');
    }
}

export function authenticateUser() {
    const { applicationId, applicantId } = parseApplicationUrl(location);
    location.assign(`${location.protocol}//${location.host}/application/secure/${applicationId}/${applicantId}/offer`);
}

export function parseApplicationUrl(location: Location = window.location) {
    const [, path, applicationId, applicantId] = location.pathname.split('/');
    if (path !== 'application' || !applicationId) {
        throw new Error('Invalid URL format. Expected format: /application/{applicationId}/{applicantId}');
    }
    return { applicationId, applicantId };
}

export function isSecureLocation() {
    const [, path, secure] = location.pathname.split('/');
    return path === 'application' && secure === 'secure';
}
